/**
 * Single source of truth for team members.
 * Used on About page (compact view) and TeamMember page (full profile).
 */
export const team = [
  {
    slug: 'ca-narasimhaswamy-basavani',
    name: 'CA Narasimhaswamy Basavani',
    title: 'CEO',
    shortSummary: 'Chartered Accountant and stock market trainer. Delivered training to 5,000+ learners across institutions.',
    bio: [
      'CA Narasimhaswamy Basavani is the Founder and CEO of InvFly. He is a Chartered Accountant and experienced stock market trainer with strong practical knowledge of financial markets, accounting, taxation, and investment analysis.',
      'He has delivered high-impact finance and stock market training to 5,000+ learners across colleges, institutions, and professional platforms. He focuses on real-time market learning, clear logic, and practical execution. His teaching style helps beginners and traders understand markets with confidence.',
      'He combines CA expertise, market experience, and teaching skills to build simple, practical, and result-oriented learning systems at InvFly.'
    ],
    expertise: [
      'Stock Markets & Technical Analysis',
      'Trading Psychology & Risk Management',
      'Fundamental Analysis of Companies',
      'Financial Statement Analysis',
      'Security Analysis & Portfolio Management',
      'Derivatives, Hedging & Risk Management',
      'Corporate Finance & Business Valuation',
      'Financial Modelling & Cash Flow Analysis'
    ],
    linkedin: 'https://www.linkedin.com/in/ca-narasimha-swamy-basavani-65443815a/',
    initials: 'CA',
    isFounder: true
  },
  {
    slug: 'dr-purushottam-naidu',
    name: 'Dr. M. Purushottam Naidu',
    title: 'Senior Trainer',
    shortSummary: 'Senior finance trainer with 24+ years in teaching, training & research. PhD in Predictive Finance. Focus on practical, data-driven education.',
    bio: [
      'Dr. M. Purushottam Naidu is a senior finance trainer with 24+ years of experience in teaching, training, and research. He focuses on finance education that is practical, data-driven, and easy to understand. He connects classroom concepts with real market application.',
      'He holds a PhD in Predictive Finance with Machine Learning and actively publishes research in reputed international journals. He trains UG, PG, CA, CMA, and ACCA students using live data and case-based learning.',
      'At InvFly, he helps learners build strong fundamentals and professional-level thinking in finance and investment analysis.'
    ],
    expertise: [
      'Financial Accounting & Reporting',
      'Cost and Management Accounting',
      'Corporate Finance & Financial Management',
      'Security Analysis & Portfolio Management',
      'Fundamental Analysis of Stocks',
      'Investment Banking & Business Valuation',
      'Financial Modelling with live market data',
      'Financial Analytics and Data-driven decision making',
      'Bloomberg Terminal–based market analysis',
      'Predictive Finance using Machine Learning and Python'
    ],
    linkedin: 'https://www.linkedin.com/in/dr-m-purushottam-naidu-04062a90/',
    initials: 'DP',
    isFounder: false
  },
  {
    slug: 'ca-irfan-abdul',
    name: 'CA Irfan Abdul',
    title: 'Senior Trainer',
    shortSummary: 'CA with 10+ years in BFSI & capital markets education. SEBI SMART empanelled for investor awareness and financial literacy courses.',
    bio: [
      'CA Irfan Abdul is an experienced Chartered Accountant and financial literacy trainer with 10+ years of experience in banking, financial services, and capital markets education. He is empanelled under SEBI\'s SMART initiative, where he delivers investor awareness and financial education courses.',
      'He focuses on financial literacy, personal finance, and capital market awareness for students, educators, and professionals. His sessions follow SEBI guidelines, are non-commercial, and focus purely on education and awareness.'
    ],
    expertise: [
      'Financial Literacy & Investor Awareness',
      'Capital Markets & Mutual Funds',
      'Personal Finance for Students and Youth',
      'BFSI Corporate Training',
      'Career Awareness in Finance & Capital Markets'
    ],
    linkedin: 'https://www.linkedin.com/in/ca-irfan-abdul-b3584a118',
    initials: 'IA',
    isFounder: false
  }
];

export const getTeamMemberBySlug = (slug) => team.find((m) => m.slug === slug);
